// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"f48504ad","455":"1d41bc25","750":"200e794d","977":"debf1c2f"}[chunkId] + ".chunk.js";
};